/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible component output html static file location types.
 * @export
 */
export type ComponentOutputHtmlStaticFileLocationType =
  | ComponentOutputHtmlStaticFileLocationTypeFooter
  | ComponentOutputHtmlStaticFileLocationTypeHeader;

/**
 * The html static file footer location type.
 * @export
 */
export type ComponentOutputHtmlStaticFileLocationTypeFooter = typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_LOCATION_FOOTER;

/**
 * The html static file header location type.
 * @export
 */
export type ComponentOutputHtmlStaticFileLocationTypeHeader = typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_LOCATION_HEADER;

/**
 * The html static file footer location constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_LOCATION_FOOTER = 'footer';

/**
 * The html static file header location constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_LOCATION_HEADER = 'header';
